import { Layer, Source } from 'react-map-gl';
import type { MultiPolygon, Polygon } from 'geojson';
import type { Pieces } from './types';
import { piecesToGeometry } from './utils';

const SOURCE = 'area-edit-parts';
/** The edited area's fill, which the name tooltip hit-tests. */
export const EDITED_FILL_LAYER = `${SOURCE}-fill`;

interface EditedAreaLayerProps {
  pieces: Pieces;
  /** The shape whose holes the parts left as they were keep, as the save does. */
  holesFrom?: Polygon | MultiPolygon | null;
  color: string;
}

/**
 * The area being edited, as the mock paints it: its colour at 0.12 under a 2px
 * line.
 *
 * @param {EditedAreaLayerProps} props - The parts, their holes' source and their colour.
 * @return {JSX.Element | null} The fill and line, or nothing with no parts.
 */
export function EditedAreaLayer({
  pieces,
  holesFrom = null,
  color,
}: EditedAreaLayerProps): JSX.Element | null {
  if (pieces.length === 0) return null;
  return (
    <Source
      id={SOURCE}
      type="geojson"
      data={{
        type: 'Feature',
        properties: {},
        geometry: piecesToGeometry(pieces, holesFrom),
      }}
    >
      <Layer
        id={EDITED_FILL_LAYER}
        type="fill"
        paint={{ 'fill-color': color, 'fill-opacity': 0.12 }}
      />
      <Layer
        id={`${SOURCE}-line`}
        type="line"
        paint={{ 'line-color': color, 'line-width': 2 }}
      />
    </Source>
  );
}
